import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import MuiExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import ButtonBase from './Buttons/ButtonBase';

const maleAvatar = '/img/avatars/avatares-cuadro-h.svg';
const femaleAvatar = '/img/avatars/avatares-cuadro-m.svg';
const lawFirmAvatar = '/img/avatars/avatares-cuadro-logo.svg';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    marginBottom: 16,
    '&:$last-child': {
      margin: 0
    },
  },
  exp_panel: {
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.12)',
  },
  heading: {
    //fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightBold,
    color: '#10587f',
    lineHeight: 'normal',
    marginRight: 40,
  },
  /* more_icon: {
    alignItems: 'flex-start',
    color: '#013957',
  }, */
  summary_info: {
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'center',
  },
  text: {
    lineHeight: 'normal',
    color: '#484848',
    marginTop: 3,
  },
  details: {
    padding: '0 16px 16px',
    '@media (max-width: 768px)': {
      padding: '0 24px 16px',
    },
  },
  item: {
    marginBottom: 8,
  },
  delete: {
    alignItems: 'flex-end',
    color: '#10587f',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  figure: {
    marginRight: 24,
    width: 104,
    height: 104,
    fontSize: 0,
    overflow: 'hidden',
    borderRadius: 4,
  },
}));

const ExpansionPanelSummary = withStyles({
  root: {
    padding: '0 16px',
    '@media (max-width: 768px)': {
      padding: '0 16px 0 24px',
    },
  },
  expandIcon: {
    color: '#013957',
    alignSelf: 'flex-start',
  },
  expanded: {},
})(MuiExpansionPanelSummary);

export default function LawyerContacted(props) {
  const {
    name,
    location,
    mobile,
    office,
    email,
    whatsapp,
    website,
    image,
    role,
    gender
  } = props;
  const classes = useStyles();
  const tabletSize = useMediaQuery('(max-width: 768px)');

  const defaultAvatar =
    role && role === 'lawyer'
      ? gender === 'male'
        ? maleAvatar
        : femaleAvatar
      : lawFirmAvatar;

  return (
    <div className={classes.root}>
      <ExpansionPanel className={classes.exp_panel}>
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <div style={{ display: 'flex' }}>
            <figure className={classes.figure}>
              <img
                src={image? image : defaultAvatar}
                alt={name}
                style={{ width: '100%', height: 'auto' }}
              />
            </figure>
            {tabletSize ? (
              <div className={classes.summary_info}>
                <Typography className={classes.heading} variant="h6">
                  {name}
                </Typography>
                <Typography variant="body2" className={classes.text}>
                  {location}
                </Typography>
              </div>
            ) : (
              <div>
                <Typography className={classes.heading} variant="h6">
                  {name}
                </Typography>
                <Typography variant="body2" className={classes.text}>
                  {location}
                </Typography>
                <div
                  style={{ display: 'flex', flexWrap: 'wrap', marginTop: 8 }}
                >
                  <div>
                    <Typography className={classes.heading} variant="subtitle1">
                      Teléfono oficina
                    </Typography>
                    <Typography variant="body2" className={classes.text}>
                      {office}
                    </Typography>
                  </div>
                  <div>
                    <Typography className={classes.heading} variant="subtitle1">
                      Teléfono móvil
                    </Typography>
                    <Typography variant="body2" className={classes.text}>
                      {mobile}
                    </Typography>
                  </div>
                  <div>
                    <Typography className={classes.heading} variant="subtitle1">
                      Correo electrónico
                    </Typography>
                    <Typography variant="body2" className={classes.text}>
                      {email}
                    </Typography>
                  </div>
                </div>
              </div>
            )}
          </div>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails className={classes.details}>
          {tabletSize ? (
            <div style={{ width: '100%' }}>
              <ButtonBase
                variant="primary"
                style={{
                  minWidth: 104,
                  marginRight: 24,
                  marginBottom: 8,
                  boxSizing: 'border-box',
                }}
              >
                Ver perfil
              </ButtonBase>
              <div style={{ display: 'flex' }} className={classes.item}>
                <div>
                  <Typography className={classes.heading} variant="subtitle1">
                    Teléfono móvil
                  </Typography>
                  <Typography variant="body2" className={classes.text}>
                    {mobile}
                  </Typography>
                </div>
                <div>
                  <Typography className={classes.heading} variant="subtitle1">
                    Teléfono Oficina
                  </Typography>
                  <Typography variant="body2" className={classes.text}>
                    {office}
                  </Typography>
                </div>
              </div>
              <div className={classes.item}>
                <Typography className={classes.heading} variant="subtitle1">
                  WhatsApp
                </Typography>
                <Typography variant="body2" className={classes.text}>
                  {whatsapp}
                </Typography>
              </div>
              <div className={classes.item}>
                <Typography className={classes.heading} variant="subtitle1">
                  Sitio de Internet o Blog
                </Typography>
                <Typography variant="body2" className={classes.text}>
                  {website}
                </Typography>
              </div>
              <div className={classes.item}>
                <Typography className={classes.heading} variant="subtitle1">
                  Correo electrónico
                </Typography>
                <Typography variant="body2" className={classes.text}>
                  {email}
                </Typography>
              </div>
              <div className={classes.delete}>
                <Typography variant="body2">Eliminar</Typography>
              </div>
            </div>
          ) : (
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%',
              }}
            >
              <div style={{ display: 'flex' }}>
                <ButtonBase
                  variant="primary"
                  style={{
                    minWidth: 104,
                    marginRight: 24,
                    boxSizing: 'border-box',
                  }}
                >
                  Ver perfil
                </ButtonBase>
                <div>
                  <Typography className={classes.heading} variant="subtitle1">
                    WhatsApp
                  </Typography>
                  <Typography variant="body2" className={classes.text}>
                    {whatsapp}
                  </Typography>
                </div>
                <div>
                  <Typography className={classes.heading} variant="subtitle1">
                    Sitio de Internet o Blog
                  </Typography>
                  <Typography variant="body2" className={classes.text}>
                    {website}
                  </Typography>
                </div>
              </div>

              <div className={classes.delete}>
                <Typography variant="body2">Eliminar</Typography>
              </div>
            </div>
          )}
        </ExpansionPanelDetails>
      </ExpansionPanel>
    </div>
  );
}
